import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {WidgetData} from "../../../../../../../../core/shared/widget/widget-data";
import {WidgetFactory} from "../../../../../../../../core/shared/widget/service/widget.factory";
import {FilterCriteria} from "../../../../../../../../core/shared/filter/api/filter.criteria";
import {
    WidgetFunctionCallBackCreate,
    WidgetToolbarCreateInterface
} from "../../../../../../../../core/shared/helper/widget-function-call-back-create";
import {ObjectIdentifier} from "../../../../../../../../core/shared/basic/object-identifier";
import {ObjectIdentifierData} from "../../../../../../../../core/shared/basic/object-identifier-data";
import {
    MvsObjectNavigationService
} from "../../../../../../../../core/shared/navigation/mvs-object-navigation.service";
import {
    MvsObjectNavigationEntry
} from "../../../../../../../../core/shared/navigation/mvs-object-navigation-entry";
import {
    MvsObjectNavigationActionEnum
} from "../../../../../../../../core/shared/navigation/mvs-object-navigation-action-enum";


/**
 * Stable widget alias so column widths, sort order, and other widget-level
 * user preferences persist across re-renders (CONFIG-011).
 */
const RULES_WIDGET_ALIAS = 'ei.importType.rules.widget';


@Component({
    selector: 'ei-import-type-rules-component',
    templateUrl: 'ei-import-type-rules.component.html',
    standalone: false
})
export class EiImportTypeRulesComponent implements OnInit, OnChanges {

    @Input() importTypeId: number;

    initialized: boolean;
    rulesWidget: WidgetData;

    private builtForId: number;

    constructor(
        protected navigationService: MvsObjectNavigationService,
    ) {
    }

    ngOnInit() {
        this.initComponent();
        this.initialized = true;
    }

    initComponent() {
        if (!this.importTypeId) {
            return;
        }
        // Skip rebuild on every change-detection pass; only rebuild when the parent id actually changes.
        if (this.rulesWidget && this.builtForId === this.importTypeId) {
            return;
        }
        this.rulesWidget = this.buildRulesWidget();
        this.builtForId = this.importTypeId;
    }

    onItemSelect(event: ObjectIdentifierData | ObjectIdentifier) {
        if (!event?.objectId) {
            return;
        }
        const entry = MvsObjectNavigationEntry.createNavigationEntry(
            'ei.EiFieldRule',
            event.objectId,
            'object', '', '', '',
            MvsObjectNavigationActionEnum.edit
        );
        this.navigationService.navigateTo(entry, 'main');
    }

    private buildRulesWidget(): WidgetData {
        const filters: FilterCriteria[] = [
            FilterCriteria.create('e.importTypeId', FilterCriteria.cOperatorEqual, this.importTypeId),
        ];

        const widget = WidgetFactory.createWidgetTableEntityFkeyResolveQl(
            RULES_WIDGET_ALIAS,
            'Regeln',
            'ei.EiFieldRule',
            filters,
            []
        );

        // FK defaulting on create (CONFIG-012)
        const fields: WidgetToolbarCreateInterface[] = [
            {fieldName: 'importTypeDtoId', fieldValue: this.importTypeId}
        ];
        widget.functionCallbacks = WidgetFunctionCallBackCreate.widgetToolbarCreate(fields);
        return widget;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!this.initialized) {
            return;
        }
        this.initComponent();
    }

}
